/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PlusSvg from 'images/v5/icons/plus.svg';
import styles from './Accordion.module.scss';
function Accordion({ opened = false, onClick = null, header = null, specHeader = null, noBorder = false, children, }) {
    var _a;
    const [isOpening, setIsOpening] = useState(false);
    const [isOpened, setIsOpened] = useState(false);
    const childRef = useRef(null);
    const contentRef = useRef(null);
    const closeFrameRef = useRef(null);
    const toggle = useCallback((open) => {
        if (closeFrameRef.current) {
            cancelAnimationFrame(closeFrameRef.current);
            closeFrameRef.current = null;
        }
        if (open) {
            setIsOpening(true);
            return;
        }
        // Pin the current height first so the collapse can animate from it instead of from `auto`.
        setIsOpened(false);
        closeFrameRef.current = requestAnimationFrame(() => {
            var _a;
            closeFrameRef.current = null;
            // Forcing layout commits the pinned height before it transitions to 0.
            (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            setIsOpening(false);
        });
    }, []);
    useEffect(() => {
        toggle(opened);
    }, [opened, toggle]);
    useEffect(() => {
        if (!isOpening) {
            return undefined;
        }
        // Once expanded, let the content size itself so later changes are not clipped.
        const timeoutId = setTimeout(() => setIsOpened(true), 300);
        return () => clearTimeout(timeoutId);
    }, [isOpening]);
    useEffect(() => () => {
        if (closeFrameRef.current) {
            cancelAnimationFrame(closeFrameRef.current);
        }
    }, []);
    const handleHeaderClick = () => {
        if (onClick) {
            onClick();
        }
        else {
            toggle(!isOpening);
        }
    };
    let contentHeight = 0;
    if (isOpening) {
        contentHeight = isOpened ? 'auto' : (_a = childRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
    }
    return (React.createElement(React.Fragment, null,
        header && (React.createElement("div", { className: styles.header, onClick: handleHeaderClick, "data-accordion-opened": isOpening }, header)),
        specHeader && (React.createElement("div", { className: classNames(styles.specHeader, {
                [styles.noBorder]: noBorder,
                [styles.opened]: opened,
            }), onClick: handleHeaderClick },
            specHeader,
            React.createElement(PlusSvg, null))),
        React.createElement("div", { ref: contentRef, className: classNames(styles.content, {
                [styles.bordered]: specHeader,
            }), style: { height: contentHeight } },
            React.createElement("div", { className: styles.contentChild, ref: childRef }, children))));
}
export default Accordion;
